
/**
 * UseTitle 是一个接受字符串并将文档标题设置为该字符串的函数。
 * @param {string} title - 文档标题
 */
export const useTitle = (title: string) => {
  document.title = title
}

/**
 * 函数 useDevice 检查用户代理字符串是否指示该设备是移动设备。
 * @returns 一个布尔值，指示当前设备是否是移动设备。
 */
export const useDeviceType = (): boolean => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
}
